import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CerebroTareas from './pages/CerebroTareas';
import TableroLideres from './pages/TableroLideres';
import Propuestas from './pages/Propuestas';
import Marketing from './pages/comercial/Marketing';
import PostVenta from './pages/comercial/PostVenta';
import RedesSociales from './pages/comercial/RedesSociales';
import Reportes from './pages/comercial/Reportes';
import EncuestaPublica from './pages/comercial/EncuestaPublica';
import Finanzas from './pages/Finanzas';
import Informes from './pages/Informes';
import KPIs from './pages/KPIs';
import Plantillas from './pages/Plantillas';
import PanelControl from './pages/PanelControl';
import ContactoClientes from './pages/ContactoClientes';
import MisTareas from './pages/MisTareas';
import MisTareasRealizadas from './pages/MisTareasRealizadas';
import ReporteTareas from './pages/ReporteTareas';
import ConfigNotificaciones from './pages/ConfigNotificaciones';
import Oportunidades from './pages/Oportunidades';
import TareasEnRevision from './pages/TareasEnRevision';
import MasterClientes from './pages/MasterClientes';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import '@/App.css';

// Componente wrapper para mostrar el Footer solo en rutas protegidas
const AppContent = () => {
  const location = useLocation();
  const showFooter = location.pathname !== '/login';

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cerebro"
          element={
            <ProtectedRoute>
              <CerebroTareas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tablero-lideres"
          element={
            <ProtectedRoute>
              <TableroLideres />
              </ProtectedRoute>
            }
          />
          <Route
            path="/propuestas"
            element={
              <ProtectedRoute>
                <Propuestas />
              </ProtectedRoute>
            }
          />
          {/* ===== Comercial y Marketing ===== */}
          <Route path="/encuesta/:token" element={<EncuestaPublica />} />
          <Route path="/comercial" element={<Navigate to="/comercial/venta" replace />} />
          <Route
            path="/comercial/venta"
            element={
              <ProtectedRoute>
                <Propuestas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comercial/post-venta"
            element={
              <ProtectedRoute>
                <PostVenta />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comercial/marketing"
            element={
              <ProtectedRoute>
                <Marketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comercial/redes-sociales"
            element={
              <ProtectedRoute>
                <RedesSociales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comercial/reportes"
            element={
              <ProtectedRoute>
                <Reportes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing"
            element={
              <ProtectedRoute>
                <Marketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finanzas"
            element={
              <ProtectedRoute>
                <Finanzas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/informes"
            element={
              <ProtectedRoute>
                <Informes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kpis"
            element={
              <ProtectedRoute>
                <KPIs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plantillas"
            element={
              <ProtectedRoute>
                <Plantillas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/panel-control"
            element={
              <ProtectedRoute>
                <PanelControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacto-clientes"
            element={
              <ProtectedRoute>
                <ContactoClientes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mis-tareas"
            element={
              <ProtectedRoute>
                <MisTareas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mis-tareas-realizadas"
            element={
              <ProtectedRoute>
                <MisTareasRealizadas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tareas-en-revision"
            element={
              <ProtectedRoute>
                <TareasEnRevision />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reporte-tareas"
            element={
              <ProtectedRoute>
                <ReporteTareas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/config-notificaciones"
            element={
              <ProtectedRoute>
                <ConfigNotificaciones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/oportunidades"
            element={
              <ProtectedRoute>
                <Oportunidades />
              </ProtectedRoute>
            }
          />
          <Route
            path="/master-clientes"
            element={
              <ProtectedRoute>
                <MasterClientes />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        {showFooter && <Footer />}
      </>
    );
  };

function App() {
  return (
    <>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
